/**
 * axios 封装
 */
import axios from 'axios'
import config from '../config'
import { ElMessage } from 'element-plus'
import router from '../router'
import storage from './storage'
import operationalCode from '@/config/operational-code.json'
import handels from './handels'
const service = axios.create({
    baseURL: config.baseApi,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*',
        'X-LANG': handels.CurrentLangeuage(true),
    },
    transformRequest: [
        function(data) {
            let ret = ''
            for (const it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        },
    ],
})

/* 请求拦截 */
service.interceptors.request.use(req => {
    const headers = req.headers

    const userInfo = storage.getItem('userInfo') || {}
    const { token = '' } = userInfo

    if (token) {
        headers['token'] = token
    } else {
        /* 用于第三方登录回传处理 */
        const hash = window.location.hash
        const urlParams = new URLSearchParams(hash.split('?')[1])
        const urlToken = urlParams.get('token')

        urlToken && (headers['token'] = urlToken)
    }

    if (req.data instanceof FormData) {
        headers['Content-Type'] = 'multipart/form-data'
        req.transformRequest = [
            function(data) {
                return data
            },
        ]
    } else {
        switch (req.method) {
            case 'post':
            case 'put':
            case 'raw':
                headers['Content-Type'] = 'application/json'
                req.method = "post"
                req.transformRequest = [
                    function(data) {
                        return JSON.stringify(data)
                    },
                ]
                break
            case 'delete':
            case 'delete':
                headers['Content-Type'] = 'application/json'
                req.transformRequest = [
                    function(data) {
                        return JSON.stringify(data)
                    },
                ]
                break
            case 'get':
                headers['Content-Type'] = 'application/x-www-form-urlencoded'
                break
            default:
                headers['Content-Type'] = 'application/x-www-form-urlencoded'
                break
        }
    }

    return req
})

/* 响应拦截 */
service.interceptors.response.use(
    res => {
        const { code, data, msg } = res.data
            console.log("service.interceptors.response===", res.status, code)
        if (code === 1 || code === 200) {
            // 请求成功
            return { code, data, msg }
        } else {
            /* 用于website detail 权限判断 */
            const url = window.location.hash
            if (url.startsWith('#/website/') && code === 1005000) {
                location.reload(true)
                return
            }
            if ( code === 1005000) {
                //没有api权限
            }
            // ElMessage.error({
            //     message: operationalCodeMessage(code, msg),center: true,
            // })
            return { code,data,msg }
            
        }
    },
    error => {

        if (error.status === 401) {
            storage.clearItem('userInfo')
            router.replace({
                path: '/sign-in',
                query: {
                    redirect: router.currentRoute.fullPath
                }
            })
        } else {
            ElMessage.error({
                message: operationalCode[error.code] || error.message,
                center: true,
            })
        }
        return Promise.reject(error)
    }
)

/* 请求核心函数 */
function request(options) {
    options.method = options.method || 'get'
    if (options.method.toLowerCase() === 'get') {
        options.params = options.data
    }
    let isMock = config.mock
        /* 局部mock */
    if (typeof options.mock != 'undefined') {
        isMock = options.mock
    }
    /* mock */
    if (config.env === 'pro') {
        service.defaults.baseURL = config.baseApi
    } else {
        service.defaults.baseURL = isMock ? config.mockApi : config.baseApi
    }
    return service(options)
}
const operationalCodeMessage = (code, msg) => {
    let message = operationalCode[code] || msg
    message = window.$L(code) || msg
    return message
}
export default request